import { render } from "./Partners.vue?vue&type=template&id=343cb70a&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=343cb70a&scoped=true&lang=css"
import "./Partners.vue?vue&type=style&index=1&id=343cb70a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343cb70a"]])

export default __exports__